<template>
  <div class="quick-order-wrap">
    <template>
      <WaitingQuickOrder
        v-if="orderInfo"
        ref="waiting"
        :quickMatchUuid="orderInfo.uuid"
        :onlyVoiceText="onlyVoiceText"
        :showCountdownPopup="showCountdownPopup"
        @finish="orderEnd"
        @error="handleError"
        @setIdentify="isSelf = $event"
      />
      <CreateQuickOrder
        v-else
        ref="create"
        :now-hour="nowHour"
        :onlyVoiceText="onlyVoiceText"
        @create="creatOrderInfo"
        @popupCountdown="showCountdownPopup"
        @error="handleError"
        @setIdentify="isSelf = $event"
      />
    </template>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import CreateQuickOrder from './quick-order-create'
import WaitingQuickOrder from './quick-order-waiting'

export default {
  components: {
    CreateQuickOrder,
    WaitingQuickOrder
  },
  data() {
    return {
      inited: false,
      orderInfo: null,
      isSelf: true,
      nowHour: new Date().getHours(),
      lastErrTime: 0,
      onlyVoiceText: i18n.t('upgrade_page_views_quick_order_index_1226'),
      showCountdownPopup: false, // 点击我要约单
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'userPermissions'])
  },
  async created() {
    this.$store.dispatch('app/getQuickOrderLegalTime')

    let quickMatch = this.userPermissions.quickMatch
    if (!Object.keys(this.userPermissions).length) {
      try {
        let data = await this.$store.dispatch('app/getWhiteListUser')
        quickMatch = data.quickMatch
      } catch(e) {
        console.log(e)
      }
    }

    if (quickMatch !== 'Open') {
      return this.$router.replace({
        name: 'homepage'
      })
    }
  },
  methods: {
    orderEnd() {
      location.reload()
    },
    // 極速約單下單錯誤處理
    handleError(err) {
      const nowTime = Date.now()
      if (nowTime - this.lastErrTime < 3000) return
      this.lastErrTime = nowTime
      if (!err) {
        this.$message.error(i18n.t('upgrade_page_views_quick_order_index_1227'))
        this.cancelLoading()
        return
      }
      if (err.code == 701) {
        this.$confirm({
          content: err.msg,
          title: i18n.t('upgrade_page_views_quick_order_index_1228'),
          confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_365'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
        }).then(() => {
          this.$router.push({
            name: 'Saving',
            query: {
              redirect: encodeURIComponent(location.href)
            }
          })
        }).catch(() => {
          this.cancelLoading()
        })
      } else {
        this.$message.error(err.msg)
        this.cancelLoading()
      }
    },
    creatOrderInfo(info, isCreate) {
      this.orderInfo = info;
      this.showCountdownPopup = !!isCreate;
    },
    cancelLoading() {
      const comp = this.$refs['create'] || this.$refs['waiting']
      if (comp && comp.isLoading) {
        comp.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .quick-order-wrap {
    width: 100%!important;
    min-height: calc(100vh - 68px);
    overflow: hidden;
    background: $color-dark;
  }
</style>
